module.exports = __webpack_public_path__ + "img/ltkitbag-1x.1b3c66c.jpg";